/**
 * Created by Administrador on 05/11/2018.
 */
(function(){
    'use strict';
    angular
        .module('completeAir')
        .controller('manageReservationCtrl', manageReservationCtrl)
        .controller('reservationCancelCtrl', reservationCancelCtrl);

    manageReservationCtrl.$inject = ['$stateParams', 'datePickerService', 'airports','linkService','dialogService',
        '$timeout','segmentFlightService','manageReservationService','dateService','$filter','paginationService',
        'AuthServerProvider'];

    reservationCancelCtrl.$inject = ['$uibModalInstance', 'manageReservationService','$stateParams','AuthServerProvider'];

    function manageReservationCtrl($stateParams, datePickerService, airports, linkService,dialogService,$timeout,
                                   segmentFlightService, manageReservationService,dateService,$filter,paginationService,
                                   AuthServerProvider){
        var vm = this;
        vm.linkService = linkService;
        vm.editIndex = -1;
        vm.userAccount = AuthServerProvider.getUserAccount();

        vm.airports = airports;
        vm.pages = paginationService.getPages();
        vm.showPages = true;
        vm.auxPnr = {};
        vm.reservations = {
            'pnrs': [],
            'datePickerOpenStatus': []
        };

        vm.dateParam = $stateParams.date;
        //vm.departureDate = new Date();
        vm.departureDate = ($stateParams.departureDate != "") ? new Date(parseInt($stateParams.departureDate)) : new Date();
        vm.today = new Date();
        vm.datePickerOpenStatus = {'date': false};
        vm.pickerButtons = datePickerService.pickerButtons();
        vm.datepickerFrom = {
            dateFormat: 'dd/MM/yyyy',
            datepickerOptions: {
                showWeeks: false,
                minDate: new Date()
            }
        };

        var fNewDate = $filter('date')(new Date(), "yyyy-MM-dd");
        var sNewDate = fNewDate + " 00:00:00";
        var newDate = new Date(sNewDate);
        vm.datepickerFlight = {
            dateFormat: 'dd/MM/yyyy',
            datepickerOptions: {
                showWeeks: false,
                minDate: newDate,
                maxDate: new Date()
            }
        };

        getAirport(true);
        getAirport(false);
        loadAll($stateParams.stretch);

        vm.openCalendar = function(index) {
            if(index == -1){
                vm.datePickerOpenStatus['date'] = true;
            }else{
                vm.reservations.datePickerOpenStatus[index].open = true;
            }

        };

        function loadAll(){
            vm.showPages = false;
            manageReservationService.getPnrReserves($stateParams.stretch, $stateParams.page, $stateParams.size)
                .then(function (response) {
                    vm.reservations.pnrs = (response.data._embedded) ? response.data._embedded.pnrs : [];
                    vm.pages = response.data.page;
                    vm.showPages = true;
                    angular.forEach(vm.reservations.pnrs, function(pnr){
                        pnr.validityDate = dateService.getDateByDateZone(pnr.validityDate),
                        pnr.validityDateTime =  dateService.convertTimeToZero(pnr.validityDate.getHours(), pnr.validityDate.getMinutes());
                        pnr.showEdit = true;
                        pnr.disabledClass = true;
                        angular.forEach(pnr._embedded.flights, function (flight) {
                            if(!flight.isReturn){
                                pnr.departureDate = dateService.getDateByDateZone(flight.departureDate)
                            }
                        });

                        vm.reservations.datePickerOpenStatus.push({'open': false});
                    });
                });
        }

        function getAirport(origin){
            if($stateParams.origin!=0 && $stateParams!=0){
                for(var c=0; c<vm.airports.length; c++){
                    if(origin){
                        if(linkService.getLinkId(vm.airports[c]._links.self.href)==$stateParams.origin){
                            vm.originAirport = vm.airports[c];
                        }
                    }else{
                        if(linkService.getLinkId(vm.airports[c]._links.self.href)==$stateParams.destiny){
                            vm.destinyAirport = vm.airports[c];
                            var date = vm.departureDate;
                            $timeout(function(){
                                segmentFlightService.getSegmentByOriginDestinyDepartureDate(vm.linkService.getLinkId(vm.originAirport._links.self.href),vm.linkService.getLinkId(vm.destinyAirport._links.self.href),date.getTime())
                                    .then(function (response) {
                                        vm.originStretches = response;
                                        for(var i=0; i<vm.originStretches.length; i++){
                                            if(vm.originStretches[i].segmentFlightId==$stateParams.stretch){
                                                vm.originStretch = vm.originStretches[i];
                                            }
                                        }
                                    });
                            }, 100);
                        }
                    }
                }
            }
        }

        vm.eventChangeStretch = function(){
            var stretch = vm.originStretch ;
            vm.editIndex = -1;
            vm.showPages = false;
            if(stretch == undefined || stretch==""){
                $timeout(function () {
                    vm.reservations.pnrs = [];
                    vm.showPages = true;
                    vm.pages = paginationService.getPages();
                },100);
            }else {
                linkService.reloadRoute(linkService.getCurrentRouteName(), {page: $stateParams.page,
                    size: $stateParams.size, origin:vm.linkService.getLinkId(vm.originAirport._links.self.href),
                    destiny:vm.linkService.getLinkId(vm.destinyAirport._links.self.href), stretch:stretch.segmentFlightId
                    ,departureDate:Date.parse(vm.departureDate)})
            }
        }

        vm.eventChangeOriginDestiny = function(){

            vm.showPages = false;
            $timeout(function () {
                vm.reservations.pnrs = [];
                vm.showPages = true;
                vm.pages = paginationService.getPages();
            },100);

            var origin = vm.originAirport;
            var destiny = vm.destinyAirport;
            var date = vm.departureDate;
            if(origin == undefined || destiny == undefined){
                vm.originStretches = [];
                vm.originPnrs = [];
            }else{
                $timeout(function(){
                    if (origin.iata == destiny.iata) {
                        dialogService.dialogError('air.manageReservation.originAndDestinyMustBeDifferent');
                        vm.destinyAirport = undefined;
                    }
                    segmentFlightService.getSegmentByOriginDestinyDepartureDate(vm.linkService.getLinkId(origin._links.self.href),vm.linkService.getLinkId(destiny._links.self.href),date.getTime())
                        .then(function (response) {
                            vm.originStretches = response;
                        });
                }, 100);
            }
        }

        vm.editPnr = function (index) {
            if (vm.editIndex == index || vm.editIndex == -1) {
                vm.reservations.pnrs[index].disabledClass = false;
                vm.reservations.pnrs[index].showEdit = false;
                vm.datepickerFlight.datepickerOptions.maxDate = vm.reservations.pnrs[index].departureDate ;
                vm.editIndex = index;
                vm.auxPnr = angular.copy(vm.reservations.pnrs[index]);
            }
        }

        vm.cancelUpdatePnr = function (index) {
            vm.reservations.pnrs[index] = angular.copy(vm.auxPnr);
            vm.reservations.pnrs[index].disabledClass = true;
            vm.reservations.pnrs[index].showEdit = true;
            vm.editIndex = -1;
            vm.auxPnr= {};
        }

        vm.updatePnr = function (valid, index) {
            if (valid) {
                var auxValidDate = $filter('date')(vm.reservations.pnrs[index].validityDate, "yyyy-MM-dd");
                var validDate = auxValidDate+" "+vm.reservations.pnrs[index].validityDateTime+":00";
                var newDate = new Date(validDate);
                if(newDate.getTime() <= vm.reservations.pnrs[index].departureDate.getTime()){
                    if(newDate.getTime()>=vm.today.getTime()){
                        manageReservationService.updatePnrReserve(vm.linkService.getLinkId(vm.reservations.pnrs[index]._links.self.href),validDate,vm.userAccount.userName)
                            .then(function (res) {
                                if (res != "ok") {
                                    vm.reservations.pnrs[index] = angular.copy(vm.auxPnr);
                                }
                                vm.reservations.pnrs[index].disabledClass = true;
                                vm.reservations.pnrs[index].showEdit = true;
                                vm.editIndex = -1;
                                vm.auxPnr = {};
                            });
                    }else{
                        dialogService.dialogError('air.manageReservation.limitEmissionMustBeGreaterThanToday');
                    }
                }else{
                    dialogService.dialogError('air.manageReservation.limitEmissionMustBeLessThanTheDepartureDate');
                }

            }
        }

        vm.deletePnr = function(codePnr){
            manageReservationService.deletePnrReserve(codePnr,vm.userAccount.userName);
        }

        vm.changeHandler = function (form, validityDate,index) {
            if(form[validityDate].$modelValue != undefined && !isNaN(form[validityDate].$modelValue)){
                form[validityDate].$setValidity('dateHigherToday', true);
                form[validityDate].$setValidity('dateLessThanDepartureDate', true);
                if(vm.reservations.pnrs[index].validityDate.getTime() >= vm.datepickerFlight.datepickerOptions.minDate.getTime()){
                    //form[validityDate].$setValidity('dateHigherToday', true);
                    var fValidDate = $filter('date')(vm.reservations.pnrs[index].validityDate, "yyyy-MM-dd");
                    var sValidDate = fValidDate+" 00:00:00";
                    var nValidDate = new Date(sValidDate);
                    if(nValidDate.getTime() > vm.reservations.pnrs[index].departureDate.getTime()) {
                        form[validityDate].$setValidity('dateLessThanDepartureDate', false);
                    }
                }else{
                    form[validityDate].$setValidity('dateHigherToday', false);
                }
            }else{
                form[validityDate].$setValidity('date', false);
            }
        }
    }

    function reservationCancelCtrl($uibModalInstance, manageReservationService,$stateParams,AuthServerProvider) {
        var vm = this;
        vm.userAccount = AuthServerProvider.getUserAccount();

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        }

        vm.deletePnr = function () {
            manageReservationService.deletePnrReserve($stateParams.id,vm.userAccount.userName)
                .then(function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
